<div class="bl-font-color--base bl-margin-top--16" [hidden]="retirementAccount?.length < 1">
  <form id="retire-account-form" #retireAccountForm="ngForm" class="bl-font-color--base">
    <div *ngFor="let account of retirementAccount; let i = index;">
      <div class="bl-margin-top--16 bl-padding-x--16 bl-padding-y--24 bl-bg-color--snow">
        <div class="bl-check-wrap dx-inValid-share">
          <input type="checkbox" name="{{account.name}}-accounts-{{i}}" [(ngModel)]="account.isSelected"
            id="{{account.name}}-accounts-{{i}}"
            [attr.data-automation-id]="'primary-retirement-accounts-'+i"
            class="bl-display--inline-block"
            (change)="primaryShareSelection(account)" />
          <label for="{{account.name}}-accounts-{{i}}"
            class="bl-font-color--black bl-font-weight--800 bl-font-size--18">
            {{account.name}}
          </label>
        </div>
        <div class="bl-font-color--black bl-font-size--16 bl-margin-top--8 bl-margin-bottom--16"
          *ngIf="account.description" [innerHtml]="account.description|safe:'html'"></div>
        <div class="bl-margin-top--8 bl-margin-bottom--8" *ngIf="account.minimumAmount">
          {{'retirementAccount/minBalance'|dictionary}}{{account.minimumAmount| currency}}
        </div>
        <div *ngIf="account.isSelected ">
          <div class="bl-margin-bottom--16 bl-margin-top--8">
            <label class="bl-required bl-font-weight--800 bl-font-size--16" for="{{account.name}}-tax">
              {{'retirementAccount/tax'|dictionary}}</label>
            <div class="bl-select-wrap  bl-margin-bottom--16">
              <select id="{{account.name}}-tax"
              [attr.data-automation-id]="'primary-retirement-accounts-tax'+i"
                class="bl-select bl-input" [disabled]="!account.isSelected"
                [(ngModel)]="account.taxYear" name="{{account.name}}-tax" #taxYear="ngModel"
                [class.validInput]="taxYear.value > 0" (change)="updateDropdownSelection(account)" required>
                <option [value]="'dropdown/defaultValue' | dictionary" disabled>{{ 'dropdown/selectOne' | dictionary
                  }}</option>
                <option *ngFor="let option of taxOptions" [value]="option.value">{{option.label}}</option>
              </select>
              <span *ngIf="isTaxValid(account)" class="bl-check-wrap-required bl-error-msg" aria-label="error"
                aria-live="assertive">This is a required field</span>
            </div>
          </div>
          <div class="bl-margin-bottom--16">
            <label class="bl-required bl-font-weight--800 bl-font-size--16" for="{{account.name}}-contributionSource">
              {{'retirementAccount/contribution'|dictionary}}</label>
            <div class="bl-select-wrap  bl-margin-bottom--16">
              <select id="{{account.name}}-contributionSource"
              [attr.data-automation-id]="'primary-retirement-accounts-contribution-source'+i"
                class="bl-select bl-input"
                [disabled]="!account.isSelected" [(ngModel)]="account.contributionSource" #contributionSource="ngModel"
                [class.validInput]="contributionSource.value > 0" name="{{account.name}}-contributionSource"
                (change)="updateDropdownSelection(account)" required>
                <option [value]="'dropdown/defaultValue' | dictionary" disabled>{{ 'dropdown/selectOne' | dictionary
                  }}</option>
                <option *ngFor="let option of contributionOptions" [value]="option.id">{{option.value}}</option>
              </select>
              <span *ngIf="isContributionSourceValid(account)" class="bl-check-wrap-required bl-error-msg"
                aria-label="error" aria-live="assertive">This is a required field</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>